import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store'
import * as echarts from "echarts";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'
import '@/router/permission'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@/styles/transition.scss'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI,{locale})

// 响应式工具函数
const baseWidth = 1920; // 设计稿基准宽度
const baseHeight = 1080; // 设计稿基准高度

function responsiveFont(fontSize) {
  const width = window.innerWidth;
  if (width < 768) {
    return (fontSize * 0.5) + 'px';
  } else if (width < 1024) {
    return (fontSize * 0.65) + 'px';
  } else if (width < 1366) {
    return (fontSize * 0.8) + 'px';
  } else if (width < 1920) {
    return (fontSize * 0.9) + 'px';
  }
  return fontSize + 'px';
}

function responsiveValue(pcValue) {
  const width = window.innerWidth;
  const scale = Math.min(width / baseWidth, window.innerHeight / baseHeight);
  return Math.round(pcValue * scale) + 'px';
}

function responsiveWidth(width) {
  const ratio = 100 / baseWidth;
  return (width * ratio) + 'vw';
}

function responsiveHeight(height) {
  const ratio = 100 / baseHeight;
  return (height * ratio) + 'vh';
}

function isMobile() {
  return window.innerWidth < 768;
}

function isTablet() {
  return window.innerWidth >= 768 && window.innerWidth < 1024;
}

Vue.prototype.$responsiveFont = responsiveFont;
Vue.prototype.$responsiveValue = responsiveValue;
Vue.prototype.$responsiveWidth = responsiveWidth;
Vue.prototype.$responsiveHeight = responsiveHeight;
Vue.prototype.$isMobile = isMobile;
Vue.prototype.$isTablet = isTablet;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
